// export
import { BASE_URL } from "constant";
import privateFetch, { privateFetchFormData } from "PrivateFetch";

// INITIAL STATE
export const INITIAL_STATE = {
    status: "",
    loading: false,
    data: [],
    error: false,
};

// CONSTANTA
export const KONTRAK_GET_LOADING = "KONTRAK_GET_LOADING";
export const KONTRAK_GET_SUCCESS = "KONTRAK_GET_SUCCESS";
export const KONTRAK_GET_ERROR = "KONTRAK_GET_ERROR";

export const KONTRAK_SAVE_LOADING = "KONTRAK_SAVE_LOADING";
export const KONTRAK_SAVE_SUCCESS = "KONTRAK_SAVE_SUCCESS";
export const KONTRAK_SAVE_ERROR = "KONTRAK_SAVE_ERROR";

export const KONTRAK_UPDATE_LOADING = "KONTRAK_UPDATE_LOADING";
export const KONTRAK_UPDATE_SUCCESS = "KONTRAK_UPDATE_SUCCESS";
export const KONTRAK_UPDATE_ERROR = "KONTRAK_UPDATE_ERROR";

export const KONTRAK_DELETE_LOADING = "KONTRAK_DELETE_LOADING";
export const KONTRAK_DELETE_SUCCESS = "KONTRAK_DELETE_SUCCESS";
export const KONTRAK_DELETE_ERROR = "KONTRAK_DELETE_ERROR";

export const KONTRAK_LIST_LOADING = "KONTRAK_LIST_LOADING";
export const KONTRAK_LIST_SUCCESS = "KONTRAK_LIST_SUCCESS";
export const KONTRAK_LIST_ERROR = "KONTRAK_LIST_ERROR";

// const dispatch

const kontrakGetLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_GET_LOADING,
        loading: bool,
    };
};

const kontrakGetSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_GET_SUCCESS,
        data,
    };
};

const kontrakGetError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_GET_ERROR,
        error: bool,
    };
};

const kontrakSaveLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_SAVE_LOADING,
        loading: bool,
    };
};

const kontrakSaveSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_SAVE_SUCCESS,
        data,
    };
};

const kontrakSaveError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_SAVE_ERROR,
        error: bool,
    };
};

const kontrakUpdateLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_UPDATE_LOADING,
        loading: bool,
    };
};

const kontrakUpdateSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_UPDATE_SUCCESS,
        data,
    };
};

const kontrakUpdateError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_UPDATE_ERROR,
        error: bool,
    };
};

const kontrakDeleteLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_DELETE_LOADING,
        loading: bool,
    };
};

const kontrakDeleteSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_DELETE_SUCCESS,
        data,
    };
};

const kontrakDeleteError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_DELETE_ERROR,
        error: bool,
    };
};

const kontrakListLoading = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_LIST_LOADING,
        loading: bool,
    };
};

const kontrakListSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_LIST_SUCCESS,
        data,
    };
};

const kontrakListError = (bool) => {
    return {
        ...INITIAL_STATE,
        type: KONTRAK_LIST_ERROR,
        error: bool,
    };
};

export function kontrakGet(data) {
    let url = BASE_URL + "master_kontrak/page";
    return privateFetch(kontrakGetSuccess, kontrakGetError, kontrakGetLoading, "POST", url, data);
}

export function kontrakSave(data) {
    let url = BASE_URL + "master_kontrak/save";
    return privateFetchFormData(
        kontrakSaveSuccess,
        kontrakSaveError,
        kontrakSaveLoading,
        "POST",
        url,
        data
    );
}

export function kontrakUpdate(data) {
    let url = BASE_URL + "master_kontrak/update";
    return privateFetchFormData(
        kontrakUpdateSuccess,
        kontrakUpdateError,
        kontrakUpdateLoading,
        "POST",
        url,
        data
    );
}

export function kontrakDelete(data) {
    let url = BASE_URL + "master_kontrak/delete";
    return privateFetch(
        kontrakDeleteSuccess,
        kontrakDeleteError,
        kontrakDeleteLoading,
        "POST",
        url,
        data
    );
}

export function kontrakList() {
    let url = BASE_URL + "kontrak/list";
    return privateFetch(kontrakListSuccess, kontrakListError, kontrakListLoading, "POST", url);
}
